export const routePaths = {
  home: "/",
  categories: "/categories",
  box: "/box"
};
